module.exports = __webpack_public_path__ + "assets/red_check_line-0bf154.svg";